import React from "react";
import { Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const HowItWork = () => {
  return (
    <div className="how-it-work">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side Content */}
          <div className="col-lg-6">
            <div className="how-work-content">
              {/* Section Title */}
              <div className="section-title">
                <h3 className="wow fadeInUp">how it works</h3>
                <h2 className="text-anime-style-3" data-cursor="-opaque">
                  Enjoy smooth and reliable travel with Aaryan Travels
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.25s">
                  At <strong>Aaryan Travels</strong>, we make your journey effortless and enjoyable. 
                  From easy booking to comfortable rides and on-time service, 
                  our process is designed to give you the best travel experience.
                </p>
              </div>

              {/* Accordion */}
              <Accordion defaultActiveKey="0" className="how-work-accordion">
                {/* Step 1 */}
                <Accordion.Item
                  eventKey="0"
                  className="wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  <Accordion.Header>
                    <div className="icon-box">
                      <img src="images/icon-how-it-work-1.svg" alt="Browse" />
                    </div>
                    Choose Your Vehicle
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Explore our wide range of well-maintained cars, SUVs, and
                      luxury vehicles. Select the ride that best suits your
                      journey — whether it’s a business trip, family vacation,
                      or airport transfer.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>

                {/* Step 2 */}
                <Accordion.Item
                  eventKey="1"
                  className="wow fadeInUp"
                  data-wow-delay="0.75s"
                >
                  <Accordion.Header>
                    <div className="icon-box">
                      <img src="images/icon-how-it-work-2.svg" alt="Book" />
                    </div>
                    Book & Confirm Instantly
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Reserve your car in just a few clicks. Our secure booking
                      system confirms your trip instantly and sends all details
                      directly to your WhatsApp or email.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>

                {/* Step 3 */}
                <Accordion.Item
                  eventKey="2"
                  className="wow fadeInUp"
                  data-wow-delay="1s"
                >
                  <Accordion.Header>
                    <div className="icon-box">
                      <img src="images/icon-how-it-work-3.svg" alt="Enjoy" />
                    </div>
                    Relax & Enjoy Your Journey
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Sit back and enjoy a comfortable ride with our professional
                      drivers and top-quality vehicles. Aaryan Travels ensures
                      safety, punctuality, and satisfaction on every trip.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          {/* Right Side Image */}
          <div className="col-lg-6">
            <div className="how-work-image">
              <div className="how-work-img">
                <figure className="reveal">
                  <img src="images/about-img-1.jpg" alt="Aaryan Travels" />
                </figure>
              </div>

              {/* Trusted Clients */}
              <div className="trusted-client">
                <div className="trusted-client-content">
                  <h3>
                    <span className="counter">10</span>k+ Happy Clients with Aaryan Travels
                  </h3>
                </div>
                <div className="trusted-client-image">
                  <img src="images/trusted-client-img.png" alt="Trusted Clients" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWork;
